import classNames from 'clsx';
import React from 'react';
import { useDispatch } from 'react-redux';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import RewardsLogo from '@swf/components/StarsRewards/components/RewardsLogo/RewardsLogo';
import Translation from '@swf/components/Translation/Translation';
import { CRMZone } from '@swf/core/enums';
import type { Dispatch } from '@swf/core/store';

import Info from '../../assets/info.svg';

import { TXTCLI_Join_our_free_Stars_Rewards_pr_ELL, TXTCLI_Start } from './Optin.messages.json';
import styles from './Optin.scss';

export interface Props {
  expanded?: boolean;
}

const OptIn: React.FC<Props> = ({ expanded, children }) => {
  const {
    modal: { replace }
  } = useDispatch<Dispatch>();

  const openRewardsOptIn = () => {
    replace([
      {
        path: `/stars-crm/${CRMZone.STARS_REWARDS_OPT_IN}`,
        locationState: { icon: 'light', componentType: 'Single' }
      }
    ]);
  };

  const openRewardsInfo = () => {
    replace([
      {
        path: `/stars-crm/${CRMZone.STARS_REWARDS_INFO}`,
        locationState: { hasCloseBtn: false, componentType: 'Single', scrolling: 'yes' }
      }
    ]);
  };

  return (
    <div className={classNames(styles.optIn, { [styles.expanded]: expanded })}>
      {expanded ? (
        <>
          <RewardsLogo inverse />
          <Info onClick={openRewardsInfo} />
          <div className={styles.intro}>
            <Translation {...TXTCLI_Join_our_free_Stars_Rewards_pr_ELL} />
          </div>
        </>
      ) : (
        <RewardsLogo />
      )}
      <StarsButton
        className={styles.button}
        variant={expanded ? 'primary' : 'secondary'}
        inverse
        size="small"
        block={expanded}
        onClick={openRewardsOptIn}
        translation={TXTCLI_Start}
      />
      {children}
    </div>
  );
};

export default OptIn;
